import { ConsultationTypeName } from '../types/ConsultationTypes'

const shouldRenderDayView = (
  consultationType: ConsultationTypeName,
  appointmentClinic?: string
): boolean => consultationType === 'physical' && appointmentClinic === 'any'

export default shouldRenderDayView
